import {Flex,  SVGButton, TextInput} from '/app/src/component';
import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import style from './style.css';

// Button
const AddNewOptionStyle = {
    dataName: 'AddNewOption',
    backgroundHover: 'LightBlue1',
    backgroundColor: 'LightGray1',
    borderRadius: '200px',
    width: '350px',
    fontSize: '24px',
    vAlignContent: 'center',
    cursor: 'pointer',
    color: 'darkgrey',
    position: 'relative',
    height: '41px',
    shrink: 0

}

const PlusButtonStyle = {
    backgroundColor: 'inherit',
    color: 'darkgrey',
    borderRadius: '200px',
    src: '/images/Plus_S.svg',
    marginRight: '20px',
}

// Edit

const AddNewOptionInputStyle = {
    dataName: 'AddNewOptionInput',
    marginTop: '5px',
    shrink: 0,
    borderRadius: '200px',
    width: '350px',
    fontSize: '24px',
    vAlignContent: 'center',
    color: 'darkgrey',
    position: 'relative',
}

const TextInputStyle = {
    placeholder: 'Lägg till ämne',
    border: '3px solid',
    borderRadius: '200px',
    color: 'blue',
    paddingLeft: '10px',
    autoFocus: true
}
const TextInputSaveButtonStyle = {
    color: 'darkgrey',
    borderRadius: '200px',
    src: '/images/Save.svg',
    position: 'absolute',
    right: '10px',
    backgroundHover: 'transparent'
}


export default ({onClick}) => {

    const [view, setView] = useState('button')
    const [text, setText] = useState('')

    if(view === 'button'){
        return (
            <Flex {...AddNewOptionStyle} onClick={()=>{setView('edit')}}>
                <SVGButton {...PlusButtonStyle}/>
                Lägg till ämne
            </Flex>
        )
    }

    const _onClick = ()=>{
        setView('button')
        onClick(text)
        setText('')
    }

    const _handleKeys= (e) => {
        if (e.key === 'Enter') {
            _onClick()
        }
        if (e.key === 'Escape') {
            setText('')
            setView('button')
        }
    }

    const TextInputProps = {
        value: text,
        onChange: (e)=>setText(e.target.value),
        onKeyDown: _handleKeys,
        maxLength: 30
    }

    return (
        <OutsideClickHandler
            onOutsideClick={()=>{_handleKeys({key: 'Escape'})}}
        >
            <Flex {...AddNewOptionInputStyle}>
                <TextInput
                    {...TextInputProps}
                    className={style.InnerTextInput}
                    {...TextInputStyle}
                />
            <SVGButton {...TextInputSaveButtonStyle} onClick={_onClick}/>
            </Flex>
        </OutsideClickHandler>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/_AddNewItem.js